module.exports = "<div class=container style=margin-top:5%> <div class=\"jumbotron text-center\"> <h1>UnAuthorized</h1> <p> <a class=\"btn btn-primary btn-lg\" ui-sref=home role=button>Back to home</a> </p> </div> </div>";


//////////////////
// WEBPACK FOOTER
// ./src/app/authorization/unauthorized/index.html
// module id = 381
// module chunks = 0